import DataLayerService from "datalayer-service/src/datalayer";

export function trackStoreLocatorClickThrough() {
  const datalayerService = new DataLayerService(window);

  $('div.store-item a,div.store-item button').on('click', function (e) {
    const element = $(e.target).closest('div.store-item');
    datalayerService.storeLocatorClickThroughEvent({
      retailerName: element.data('retailerName'),
      retailerLocation: element.data('storeSlug'),
      isLdp: element.data('isLdp'),
      position: element.data('position'),
    });
  });

}
